import { WidgetConfigBase } from '@src/types/Widget';
import useGetDevicesFiltered from './collections/useGetDevicesFiltered';
import useGetWidgetConfigs from './collections/useGetWidgetConfigs';
import { useMemo } from 'react';

export interface SimpleDevice {
  name: string;
  engineeringId: string;
  deviceId: string;
}

export interface DeviceWidgetOption extends SimpleDevice {
  widgetInternalId?: WidgetConfigBase['internalId'];
}

export default (deviceType: string) => {
  const {
    data: devices,
    isLoading: isDevicesLoading,
    isFetching: isDevicesFetching,
    error: devicesError,
  } = useGetDevicesFiltered({
    body: {
      filter: {
        type: {
          $in: [deviceType],
        },
      },
    },
    options: {
      queryKeys: [deviceType],
    },
  });

  const {
    data: widgets,
    isLoading: isWidgetsLoading,
    isFetching: isWidgetsFetching,
    error: widgetsError,
  } = useGetWidgetConfigs();

  const deviceWidgetOptions: DeviceWidgetOption[] = useMemo(() => {
    if (!devices || !widgets) {
      return [];
    }

    return devices.reduce<DeviceWidgetOption[]>((acc, device) => {
      const widget = widgets.find((widget) =>
        widget.internalId.includes(device.engineeringId),
      );

      if (widget) {
        acc.push({
          name: device.name,
          engineeringId: device.engineeringId,
          deviceId: device.deviceId,
          widgetInternalId: widget.internalId,
        });
      }

      return acc;
    }, []);
  }, [devices, widgets]);

  return {
    data: deviceWidgetOptions,
    isLoading: isDevicesLoading || isWidgetsLoading,
    isFetching: isDevicesFetching || isWidgetsFetching,
    error: devicesError || widgetsError,
  };
};
